/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/secret';
import { SECRET } from '@/store/types';
import { finalizeAction, StoreActionEnv } from '@/store/actions';
import { SecretTopic } from '@/api/types/secret';
import { StoreDataCache, findCache, saveCache } from '@/store/cache';

export interface StoreSecretTopicDetailState {
  cache: StoreDataCache<SecretTopic>[];
  maxCache: number;
}

export default {
  namespaced: true,
  state: {
    cache: [],
    maxCache: 20,
  },
  getters: {},
  actions: {
    [SECRET.GET_TOPIC](
      { commit, state }: StoreActionEnv<StoreSecretTopicDetailState>,
      { id, action: rawAction },
    ) {
      const action = finalizeAction(rawAction, findCache(state.cache, id));
      if (action) {
        return new Promise((resolve, reject) => {
          api.getTopic(id).then((res) => {
            commit(SECRET.GET_TOPIC, {
              id,
              data: res.data,
            });
            resolve();
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
    [SECRET.SET_TOPIC](
      { dispatch }: StoreActionEnv<StoreSecretTopicDetailState>,
      { id, body },
    ) {
      return new Promise((resolve, reject) => {
        api.putTopic(id, body).then(() => {
          dispatch(SECRET.GET_TOPIC, {
            id,
            action: 'refresh',
          }).then(() => resolve());
        }).catch(reject);
      });
    },
  },
  mutations: {
    [SECRET.GET_TOPIC](state: StoreSecretTopicDetailState, { data, id }) {
      saveCache(state.cache, id, data, state.maxCache);
    },
  },
};
